module.exports = __webpack_public_path__ + "img/龙骨.60cd71e5.jpg";